import { render, staticRenderFns } from "./LocationPajuPage.vue?vue&type=template&id=23dc74cc&scoped=true&"
import script from "./LocationPajuPage.vue?vue&type=script&lang=js&"
export * from "./LocationPajuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc74cc",
  null
  
)

export default component.exports